import { toast } from "sonner";
import { getEntityTypeFromPAN } from "./constants";

const csvEscape = (val) => `"${String(val ?? "").replace(/"/g, '""')}"`;

const buildCsvRows = (filteredTransactions, totals) => {
  const headers = [
    "Date", "Party Name", "PAN", "Entity Type", "TDS Ledger", "Amount", "TDS (XML)",
    "TDS (Matched)", "TDS Amount", "Applied Rate", "Expected Rate", "Mismatch",
    "Section (1961)", "Section (2025)", "User Section", "Financial Year", "Quarter",
    "Voucher No", "Excluded", "Exclusion Reason"
  ];
  const rows = [headers.join(",")];

  filteredTransactions.forEach((txn) => {
    const entityType = getEntityTypeFromPAN(txn.pan);
    rows.push([
      txn.date || "",
      csvEscape(txn.party_name),
      txn.pan || "",
      entityType?.label || (txn.pan ? "Unknown" : "No PAN"),
      csvEscape(txn.tds_ledger),
      txn.amount || 0,
      txn.tds_amount_xml != null ? txn.tds_amount_xml : "",
      txn.tds_amount_matched != null ? txn.tds_amount_matched : "",
      txn.tds_amount || 0,
      txn.tds_rate?.toFixed(2) || "",
      txn.expected_rate?.toFixed(2) || "",
      txn.rate_mismatch ? "YES" : "No",
      txn.section || "",
      csvEscape(txn.new_section || ""),
      txn.user_section || "",
      txn.financial_year || "",
      txn.quarter || "",
      txn.voucher_no || "",
      txn.is_excluded ? "YES" : "No",
      txn.is_excluded ? csvEscape(txn.exclusion_reason) : "",
    ].join(","));
  });

  rows.push("");
  rows.push(`"Total (Active)","","","","",${totals.amount},"","",${totals.tds},"","","","","","","","","","",""`);
  return rows;
};

export const exportTransactionsToCsv = ({
  activeTransactions, filteredTransactions, totals,
  selectedClient, selectedFY, selectedQuarter,
}) => {
  if (activeTransactions.length === 0) {
    toast.error("No transactions to export");
    return;
  }

  const csvContent = buildCsvRows(filteredTransactions, totals).join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  const dateStr = new Date().toISOString().split("T")[0];
  const clientName = selectedClient?.name?.replace(/[^a-zA-Z0-9]/g, "_") || "export";
  const fyStr = selectedFY && selectedFY !== "all" ? `_FY${selectedFY}` : "";
  const qtrStr = selectedQuarter && selectedQuarter !== "all" ? `_${selectedQuarter}` : "";
  link.href = url;
  link.download = `TDS_Transactions_${clientName}${fyStr}${qtrStr}_${dateStr}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  toast.success(`Exported ${filteredTransactions.length} transactions to Excel`);
};
